<template>
  <div>
    <v-dialog v-model="open" scrollable persistent max-width="700px">
      <v-card>
        <v-card-title class="py-1">
          <h2>{{ title }}</h2>
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('onClose', false)">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="max-height: 800px">
          <FollowUpTaskList :value="filterTasks" />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-layout row wrap justify-space-between align-center>
            <v-flex xs4 style="display: flex; align-items: baseline">
              <span class="mr-1">{{ $t('follow_up.total') }}:</span>
              <h3>{{ taskItems.length }}</h3>
            </v-flex>
            <v-flex xs8 class="text-xs-right">
              <v-pagination v-model="page" :length="pageCount" :total-visible="7"
            /></v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs'

import FollowUpTaskList from './FollowUpTaskList.vue'

export default {
  components: {
    FollowUpTaskList
  },
  props: {
    selectedDate: {
      type: String,
      default: ''
    },
    dialogOpen: {
      type: Boolean,
      default: false
    },
    item: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      open: this.dialogOpen,
      taskItems: [],
      maxItems: 20,
      page: 1
    }
  },
  computed: {
    title() {
      return this.selectedDate ? dayjs(this.selectedDate).format('DD MMMM YYYY') : ''
    },
    pageCount() {
      if (this.taskItems) {
        let total = this.taskItems.length || 0
        let limit = this.maxItems
        return Math.ceil(total / limit)
      }

      return 0
    },
    filterTasks() {
      if (this.taskItems) {
        const tasks = this.taskItems || []
        const start = (this.page - 1) * this.maxItems
        const end = start + this.maxItems
        return tasks.slice(start, end)
      }

      return []
    }
  },
  watch: {
    dialogOpen: {
      handler() {
        this.open = this.dialogOpen
      }
    },
    item: {
      handler() {
        this.taskItems = this.item
      }
    }
  },
  mounted() {
    this.open = this.dialogOpen
    this.taskItems = this.item
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/Kmb/FollowUp/FollowUpViewTaskDialog.vue